<div class="progress-bar-wrapper">

    @for (step of [].constructor(steps); track step; let i = $count) {
        <ion-progress-bar [value]="+(i < value)" />
    }

</div>
